// Flavour-specific default brand presets
// These apply when site_config.settings.branding is not configured.
//
// Only the fields the app actually reads live here. The old presets also
// carried primaryColor / accentColor / borderRadius, but nothing ever applied
// them: the brand colour is the Corteh orange in index.css, and radii are
// explicit steps in the @theme block.

export interface BrandPreset {
  fontFamily: string;
  displayFontFamily: string;
  monoFontFamily: string;
  darkDefault: boolean;
}

export const FLAVOUR_PRESETS: Record<string, BrandPreset> = {
  hospitality: {
    fontFamily: 'Inter',
    displayFontFamily: 'Manrope',
    monoFontFamily: 'Geist Mono',
    darkDefault: false,
  },
  residential: {
    fontFamily: 'Inter',
    displayFontFamily: 'Manrope',
    monoFontFamily: 'Geist Mono',
    darkDefault: false,
  },
  commercial: {
    fontFamily: 'Inter',
    displayFontFamily: 'Manrope',
    monoFontFamily: 'Geist Mono',
    darkDefault: false,
  },
};

// Default preset when space_category is unknown
export const DEFAULT_PRESET: BrandPreset = FLAVOUR_PRESETS.residential;
